import React from 'react'
import style from './Verify.Module.css'
import progress from '../../Assets/verify/Group 202.png'
import image from '../../Assets/verify/Rectangle 249.png'
// import cupload from '../../Assets/verify/bi_upload.png'
// import images from '../../Assets/verify/Group 154.png'
import Header from '../../Component/Header'
import Upload from '../../Component/Upload'

const VerifyThree = () => {
    return (
        <div className={style.mainContainer}>
        <Header/>
        <div className={style.main}>
          <div className={style.boxContainer}>
            <div className={style.boxInsidecontainer}>
            
                    <div><h1 className={style.verifyHeading}>Verify your account</h1></div>
                    <div><img src={progress} alt="progress icon"/></div>
                   
                    <div className={style.uploadImages}> 
                    <div className={ style.imageHolder}> <img src={image} alt="demo pic"/></div>
                    <Upload/>
                    {/* <div className={style.imageHolders}>
                    <div className={style.imageHold}><img src={images} className={style.imag} alt="upload icon"/></div>
                        <div className={style.imageHolderss}>
                            
                            
                       <img src={cupload} alt="upload icon"/> <label htmlFor="input" className={style.imageUpload}>Choose file</label>
                        <input className={style.imageUpload} type="file" id="input" accept="images/*"/></div>
                        </div> */}
                        </div>
                    <div><p className={style.verifyParagraph}>To verify yourself take a picture with the same<br/>gestures as the one above</p></div>
                    <div><button className={style.mainButton}>Next</button></div>
                    <div><p className={style.verifyParagraphh}>This picture will not be used for verification and will<br/>not be shown to others</p></div>
                
            
            </div>
        </div>
        </div>
        </div>
    )

}

export default VerifyThree
